<template>
  <div class="app-container">
    <BjDivider right-fixed>
      <span></span>
      <template #right>
        <template v-if="isAudit">
          <el-button v-if="pendingAudit" type="primary" @click="onPass">{{ $t('goodsAudit.detail.Pass') }}</el-button>
          <el-button v-if="pendingAudit" type="warning" @click="onReject">{{ $t('goodsAudit.detail.Reject') }}</el-button>
        </template>
        <el-button @click="cancel">{{ $t('backText') }}</el-button>
        <BjLogButton :id="data.id" permission="BusinessGoodsAuditSkuPackage_Log" :title="data.name" api="goodsApi" />
      </template>
    </BjDivider>
    <el-table :data="[{}]" border :show-header="false" :cell-style="handleCellStyle()">
      <el-table-column :width="labelWidth"> </el-table-column>
      <el-table-column prop="value" align="center">
        <template>
          <h3>{{ data.draftSkuVO ? $t('goodsAudit.detail.BeforeModification') : $t('goodsAudit.detail.ProductDetails') }}</h3>
        </template>
      </el-table-column>
      <el-table-column v-if="data.draftSkuVO" prop="newValue" align="center">
        <template>
          <h3>{{ $t('goodsAudit.detail.AfterModification') }}</h3>
        </template>
      </el-table-column>
    </el-table>

    <BjDivider>{{ $t('goodsAudit.detail.BasicInformation') }}</BjDivider>
    <el-table v-if="setFlag===0" :data="baseAttribute" border :show-header="false" :cell-style="handleCellStyle">
      <el-table-column prop="name" align="center" :width="labelWidth">
        <template slot-scope="scope">
          <span :type="checkData(scope.row) ? color : ''" class="link">{{ $t('goodsPage.' + scope.row.key) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="value" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.key==='asignBarcode'"> <el-switch v-model="row.value" disabled /></span>
          <span v-else-if="row.key==='discontinued'"> <el-switch v-model="row.value" disabled /></span>
          <span v-else-if="row.key==='seasonable'"> All Seasonable</span>
          <span v-else-if="row.key==='fragile'"> <el-switch v-model="row.value" disabled /></span>
          <span v-else-if="row.key==='needExpired'"> <el-switch v-model="row.value" disabled /></span>
          <span v-else-if="row.key==='purchaseItem'"> <el-switch v-model="row.value" disabled /></span>
          <span v-else-if="row.key==='salesItem'"> <el-switch v-model="row.value" disabled /></span>
          <span v-else-if="row.key==='inventoryItem'"> <el-switch v-model="row.value" disabled /></span>
          <span v-else-if="row.key==='dangerousGoods'"> <el-switch v-model="row.value" disabled /></span>
          <span v-else-if="row.key==='flammable'"> <el-switch v-model="row.value" disabled /></span>
          <span v-else-if="row.key==='imageUrl'" class="flex-center"> <BjKeyImage v-if="row.value" class="avatar" :url="row.value" preview fit="cover" /></span>
          <span v-else :type="checkData(row) ? color : ''" :underline="false">{{ row.value }}
          </span>
        </template>
      </el-table-column>
      <el-table-column v-if="data.draftSkuVO" prop="newValue" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.key==='asignBarcode'"> <el-switch v-model="row.newValue" disabled /></span>
          <span v-else-if="row.key==='discontinued'"> <el-switch v-model="row.newValue" disabled /></span>
          <span v-else-if="row.key==='seasonable'"> All Seasonable</span>
          <span v-else-if="row.key==='fragile'"> <el-switch v-model="row.newValue" disabled /></span>
          <span v-else-if="row.key==='needExpired'"> <el-switch v-model="row.newValue" disabled /></span>
          <span v-else-if="row.key==='purchaseItem'"> <el-switch v-model="row.newValue" disabled /></span>
          <span v-else-if="row.key==='salesItem'"> <el-switch v-model="row.newValue" disabled /></span>
          <span v-else-if="row.key==='inventoryItem'"> <el-switch v-model="row.newValue" disabled /></span>
          <span v-else-if="row.key==='dangerousGoods'"> <el-switch v-model="row.newValue" disabled /></span>
          <span v-else-if="row.key==='flammable'"> <el-switch v-model="row.newValue" disabled /></span>
          <span v-else-if="row.key==='imageUrl'" class="flex-center"> <BjKeyImage v-if="row.newValue" class="avatar" :url="row.newValue" preview fit="cover" /></span>
          <span v-else :type="checkData(row) ? color : ''" :underline="false">{{ row.newValue }}
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-table v-if="setFlag===1" :data="skuPackageAttributeList" border :show-header="false" :cell-style="handleCellStyle">
      <el-table-column prop="name" align="center" :width="labelWidth">
        <template slot-scope="scope">
          <span :type="checkData(scope.row) ? color : ''" class="link">{{ $t('goodsPage.' + scope.row.key) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="value" align="center">
      </el-table-column>
      <el-table-column v-if="data.draftSkuVO" prop="newValue" align="center">
      </el-table-column>
    </el-table>

    <BjDivider v-if="setFlag===0">{{ $t('goodsAudit.detail.attribute') }}</BjDivider>
    <el-table v-if="setFlag===0" :data="newSkuAttribute" border :show-header="false" :cell-style="handleCellStyle">
      <el-table-column prop="name" align="center" :width="labelWidth">
        <template slot-scope="{ row }">
          <span :type="checkData(row) ? color : ''" :underline="false">{{ $t('goodsSku.detail.' + row.key) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="value" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.key==='UnitVolume'">{{ data.thisSkuVO && (data.thisSkuVO['width']*data.thisSkuVO.length*data.thisSkuVO.height / 1000000) }}m³</span>
          <span v-else-if="row.key==='Volume'">{{ data.thisSkuVO && (data.thisSkuVO['cartonWidth']*data.thisSkuVO.cartonLength*data.thisSkuVO.cartonHeight / 1000000) }}m³</span>
          <span v-else :type="checkData(row) ? color : ''" :underline="false">{{ row.value }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="data.draftSkuVO" prop="newValue" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.key==='UnitVolume'">{{ data.draftSkuVO && (data.draftSkuVO['width']*data.draftSkuVO.length*data.draftSkuVO.height / 1000000) }}m³</span>
          <span v-if="row.key==='Volume'">{{ data.draftSkuVO && (data.draftSkuVO['cartonWidth']*data.draftSkuVO.cartonLength*data.draftSkuVO.cartonHeight / 1000000) }}m³</span>
          <span :type="checkData(row) ? color : ''" :underline="false">{{ row.newValue }}
          </span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 套餐sku -->
    <BjDivider v-if="setFlag===1">{{ $t('goodsAudit.detail.packageSku') }}</BjDivider>
    <el-table v-if="setFlag===1" :data="skuDetailList" border :show-header="false" :cell-style="handleCellStyle">
      <el-table-column prop="name" align="center" :width="labelWidth" />
      <el-table-column prop="value" align="center">
        <template slot-scope="scope">
          {{ scope.row.value }}
          <span class="link ml10" @click="onSkuDetail(scope.row.row)">{{ $t('detailsText') }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="data.draftSkuVO" prop="newValue" align="center">
        <template slot-scope="scope">
          {{ scope.row.newValue }}
          <span class="link ml10" @click="onSkuDetail(scope.row.newRow)">{{ $t('detailsText') }}</span>
        </template>
      </el-table-column>
    </el-table>

    <BjDivider>{{ $t('table.auditText') }}</BjDivider>
    <el-form>
      <el-row v-if="!pendingAudit">
        <el-col :span="6">
          <el-form-item :label="$t('goodsAudit.detail.status')">
            {{ $t(GOODS_AUDIT_STATUS_LIST.bjGet($route.query.status)) }}</el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item :label="$t('goodsAudit.detail.comments')">
            {{ data.thisSkuVO && data.thisSkuVO.auditIdea }}</el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <DialogIdea ref="DialogIdea" @confirm="onConfirm" />
    <RowDetailFromSkuDetailList ref="RowDetailFromSkuDetailList" :cols="skuDetailTableColumns" :handle-cell-style="handleCellStyle" />
  </div>
</template>

<script>
import viewMiXin from '@/utils/view-mixin.js';
import { goodsApi } from '@/api';
import { GOODS_AUDIT_STATUS_LIST, GOODS_COMBO_TYPES } from '@/utils/constants';
import DialogIdea from './DialogIdea';
import RowDetailFromSkuDetailList from './RowDetailFromSkuDetailList.vue';
import DefaultAttributeList from '@/views/center-business/goods/components/DefaultAttributeList.json';
const defaultFormData = () => {
  return {
    auditIdea: null,
    flag: true,
    id: null,
  };
};
const DEFAULT_SKU_COLUMNS = [
  {
    prop: 'skuName',
    label: 'SKU名称',
  },
  {
    prop: 'skuCode',
    label: 'SKU编码',
  },
];
export default {
  components: { DialogIdea, RowDetailFromSkuDetailList },
  mixins: [viewMiXin],
  props: {
    // label 宽度
    labelWidth: {
      type: String,
      default: '200px',
    },
    // 文字颜色
    color: {
      type: String,
      default: 'primary',
      validator: function(value) {
        // 这个值必须匹配下列字符串中的一个
        return ['primary', 'success', 'warning', 'danger', 'info'].indexOf(value) !== -1;
      },
    },
    setFlag: {
      type: [String, Number],
      default: GOODS_COMBO_TYPES.ORDINARY,
    },
    isAudit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      GOODS_AUDIT_STATUS_LIST,
      GOODS_COMBO_TYPES,
      labeWdith: '200px',
      DefaultAttributeList,
      // 基本属性
      baseAttribute: [
        { name: 'SKU名称', key: 'skuName', value: '', newValue: '' },
        { name: 'SKU编码', key: 'skuCode', value: '', newValue: '' },
        { name: '产品类型', key: 'itemType', value: '', newValue: ''},
        { name: '条形码', key: 'barCode', value: '', newValue: ''},
        { name: '成本价', key: 'costPrice', value: '', newValue: ''},
        { name: '描述', key: 'skuDesc', value: '', newValue: ''},
        { name: '每箱件数', key: 'qty', value: '', newValue: ''},
        // { name: '审核意见', key: 'auditIdea', value: '', newValue: ''},
        { name: '是否酒水', key: 'fragile', value: '', newValue: ''},
        { name: '是否需要批次和过期日期功能', key: 'needExpired', value: '', newValue: ''},
      ],
      // SKU属性
      skuAttribute: [],
      newSkuAttribute: [
        { name: '单位长度', key: 'length', value: '', newValue: '' },
        { name: '单位宽度', key: 'width', value: '', newValue: '' },
        { name: '单位高度', key: 'height', value: '', newValue: ''},
        { name: '单位重量', key: 'weight', value: '', newValue: ''},
        { name: '单位体积', key: 'UnitVolume', value: '', newValue: '' },
        { name: '数量', key: 'qty', value: '', newValue: '' },
        { name: '箱子长度', key: 'cartonLength', value: '', newValue: ''},
        { name: '箱子宽度', key: 'cartonWidth', value: '', newValue: ''},
        { name: '箱子高度', key: 'cartonHeight', value: '', newValue: ''},
        { name: '箱子重量', key: 'cartonWeight', value: '', newValue: ''},
        { name: '体积', key: 'Volume', value: '', newValue: ''},
      ],
      // SKU价格
      skuPrice: [],
      // 套餐SKU明细
      skuDetailList: [],
      skuPackageAttributeList: [
        { name: '产品分类', key: 'categoryName', value: '', newValue: ''},
        { name: '套餐名称', key: 'skuName', value: '', newValue: '' },
        { name: '套餐SKU编码', key: 'skuCode', value: '', newValue: '' },
        { name: '成本价', key: 'costPrice', value: '', newValue: ''},
        { name: '销售价', key: 'salesPrice', value: '', newValue: '' },
      ],
      // 证书列表
      skuLicenseList: [
        { name: '证书名称', key: 'licenseName', value: '', newValue: ''},
        { name: '证书有效期', key: 'licenseExpireDate', value: '', newValue: ''},
        { name: '证书备注', key: 'licenseNode', value: '', newValue: ''},
      ],
      // 素材
      material: [
        {
          name: '主图',
          key: 'MainImage',
          value: '',
          newValue: '',
          imgs: [],
          newImgs: [],
        },
        {
          name: '详情图',
          key: 'DetailMap',
          value: '',
          newValue: '',
        },
        {
          name: '商品描述',
          key: 'description',
          value: '',
          newValue: '',
        },
      ],
      form: defaultFormData(),
      data: {},
    };
  },
  computed: {
    // TODO: 兼容套餐SKU，套餐SKU的明细，表头
    skuDetailTableColumns() {
      // SKU_CODE SKU_NAME
      const DETAIL_COLUMNS = [...DEFAULT_SKU_COLUMNS];
      // 价格 成本价/销售价
      DETAIL_COLUMNS.push(
        ...this.skuPrice.map(e => {
          return {
            prop: e.key,
            label: e.name,
          };
        }),
      );
      DETAIL_COLUMNS.push({
        prop: 'num',
        label: '搭配数量',
      });
      return DETAIL_COLUMNS;
    },
    pendingAudit() {
      return [2, 4].includes(Number(this.$route.query.status));
    },
  },
  created() {
    // 获取sku固定属性
    this.skuAttribute = DefaultAttributeList.map(item => {
      return {
        key: item.code,
        name: item.name,
        value: null,
        newValue: null,
      };
    });
    const { id } = this.$route.query;
    this.form.id = id;
    this.getData(id);

    if (this.setFlag == GOODS_COMBO_TYPES.ORDINARY) {
      this.pageName = 'BusinessGoodsAuditSkuOrdinaryIndex';
    }
    if (this.setFlag == GOODS_COMBO_TYPES.PACKAGE) {
      this.pageName = 'BusinessGoodsAuditSkuPackageIndex';
    }
  },
  methods: {
    handleCellStyle(arg) {
      if (!arg) {
        return this.$rowStyle.DEFAULT;
      }
      if (arg.columnIndex == 0) {
        return this.$rowStyle.DEFAULT;
      }
      return {};
    },
    onSkuDetail(row) {
      // 展示数据
      this.$refs.RowDetailFromSkuDetailList.show(row);
    },
    async getData(id) {
      goodsApi
        .getSkuAuditDetail({ id })
        .then(res => {
          this.data = res;
          // 赋值修改前后SKU
          const { thisSkuVO, draftSkuVO } = res;
          const setData = ['asignBarcode', 'discontinued', 'inventoryItem', 'purchaseItem', 'salesItem', 'fragile', 'needExpired', 'dangerousGoods', 'flammable'];
          // 获取基本属性
          this.baseAttribute.forEach(item => {
            if (setData.includes(item.key)) {
              item.value = !!thisSkuVO[item.key];
            } else {
              item.value = thisSkuVO[item.key];
            }
            if (draftSkuVO) {
              if (setData.includes(item.key)) {
                item.newValue = !!draftSkuVO[item.key];
              } else {
                item.newValue = draftSkuVO[item.key];
              }
            }
          });
          this.newSkuAttribute.forEach(item => {
            if (item.key === 'Volume') {
              item.value = thisSkuVO['volumeUnit'];
            } else {
             item.value = thisSkuVO[item.key];
            }
            if (draftSkuVO) {
              if (item.key === 'Volume') {
                item.newValue = draftSkuVO['volumeUnit'];
              } else {
                item.newValue = draftSkuVO[item.key];
              }
            }
          });

          // this.skuLicenseList.forEach(item => {
          //   item.value = thisSkuVO[item.key];
          // });

          // 套餐SKU
          const setPackageData = ['costPrice', 'salesPrice'];
          this.skuPackageAttributeList.forEach(item => {
            if (setPackageData.includes(item.key)) {
              item.value = thisSkuVO.priceVO[item.key];
            } else {
              item.value = thisSkuVO[item.key];
            }
            if (draftSkuVO) {
              if (setPackageData.includes(item.key)) {
                item.newValue = draftSkuVO.priceVO[item.key];
              } else {
                item.newValue = draftSkuVO[item.key];
              }
            }
          });

          // 合并SKU属性
          // 固有属性赋值
          this.skuAttribute.forEach(item => {
            item.value = thisSkuVO[item.key];
            item.newValue = draftSkuVO && draftSkuVO[item.key];
          });
          // 获取sku属性
          const skuAttributeList = (thisSkuVO && thisSkuVO.skuAttributeList) || [];
          const newSkuAttributeList = (draftSkuVO && draftSkuVO.skuAttributeList) || [];
          const attributeList = skuAttributeList.map((item, index) => {
            return {
              key: null,
              name: item.attributeName,
              value: item.attributeValue,
              newValue: newSkuAttributeList[index]?.attributeValue,
            };
          });
          // 合并sku属性
          this.skuAttribute = [...this.skuAttribute, ...attributeList];
          // 获取 SKU价格
          goodsApi.getListPriceItem().then(res => {
            this.skuPrice = (res || []).map(e => {
              return {
                key: e.value,
                name: e.meaning,
                value: thisSkuVO.priceVO[e.value],
                newValue: draftSkuVO && draftSkuVO.priceVO[e.value],
              };
            });
          });
          // 获取 sku套餐明细
          const skuDetailList = (thisSkuVO && thisSkuVO.skuDetailList) || [];
          const newSkuDetailList = (draftSkuVO && draftSkuVO.skuDetailList) || [];

          this.skuDetailList = skuDetailList.map((item, index) => {
            let newValue;
            const newItem = newSkuDetailList[index];

            if (newItem) {
              newValue = `${newItem.skuName} x ${newItem.num}`;
            }
            return {
              key: null,
              name: `SKU${index + 1}`, // SKU1  SKU2
              value: `${item.skuName} x ${item.num}`, // SKU名称  X  搭配数量
              newValue: newValue,
              row: item, // 点击展示用的
              newRow: newItem, // 点击展示用的
            };
          });
          // 获取商品素材
          this.material.forEach(item => {
            // 图片处理成数组
            if (item.key === 'mainImage' || item.key === 'detailImage') {
              item.imgs = thisSkuVO[item.key].split(',');
              item.newImgs = draftSkuVO && draftSkuVO[item.key].split(',');
            } else {
              item.value = thisSkuVO[item.key];
              item.newValue = draftSkuVO && draftSkuVO[item.key];
            }
          });
        });
    },
    /** 通过 */
    onPass() {
      this.form.DialogIdea = null;
      this.form.flag = true;
      this.$refs.DialogIdea.show(this.$t('approvedText'));
    },
    /** 驳回 */
    onReject() {
      this.form.DialogIdea = null;
      this.form.flag = false;
      this.$refs.DialogIdea.show(this.$t('auditRejectText'));
    },
    onConfirm(data) {
      // 赋值审核意见
      this.form.auditIdea = data;
      // 调用审核接口
      goodsApi
        .skuAudit(this.form)
        .then(res => {
          if (!res.failed) {
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.$router.go(-1);
            }, 500);
          }
        });
    },
    /** 校验数据是否发生变化 */
    checkData(row) {
      if (this.data.draftSkuVO) {
        if (row.value || row.newValue) {
          return row.value !== row.newValue;
        } else {
          return JSON.stringify(row.imgs) !== JSON.stringify(row.newImgs);
        }
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.span {
  font-size: 14px;
  cursor: text;
}
</style>
